module.exports = "https://static.zego.com/_next/static/images/SecureFinanceBlack-f47365e8fe6e9b2aa33962b031f66a81.svg";